import Cache from '@fs/zion-cache'
import { mutate } from 'swr'
import type { CoupleId, FamilyMemberChild, PersonId } from '@fs/zion-tree-types'
import { useGroupsContext } from '@fs/zion-tree-groups'
import { usePersonPageParams } from '../person-page/personPageRouteUtil'
import type { SwrResponse } from './useSwrRequest'
import { useSwrRequest } from './useSwrRequest'

const cache = new Cache({ storeName: 'children_r9', encrypted: process.env.NODE_ENV === 'production' })

function swrKey(coupleId: CoupleId, pid: PersonId, treeId: string): string {
  const useFocusPersonId = pid ? `focusPersonId=${pid}` : ''
  return `/service/tree/tree-data/r9/family-members/couple/${coupleId}/children?${useFocusPersonId}&includePhotos=true&treeId=${treeId}`
}
export default function useChildren(
  coupleId: CoupleId | undefined,
  initialValue: FamilyMemberChild[] | undefined
): SwrResponse<FamilyMemberChild[]> & { children?: FamilyMemberChild[] } {
  const { currentTreeId } = useGroupsContext()
  const { pid } = usePersonPageParams('full')
  const response = useSwrRequest<FamilyMemberChild[]>(
    coupleId ? swrKey(coupleId, pid, currentTreeId || 'PRIVATE') : null,
    cache,
    {
      fallbackData: initialValue,
      // This will prevent it from making a call to the server on mount IF we already have the children passed in as initialValue
      revalidateOnMount: !initialValue,
      // This is a piece of data we don't really need to revalidate on refocus, since it would trigger a call for every spouse and set of parents (that have their children list open)
      revalidateOnFocus: false,
    }
  )
  return { ...response, children: response.data }
}
export function mutateChildren(coupleId: CoupleId, pid: PersonId, treeId: string): Promise<void> {
  return mutate(swrKey(coupleId, pid, treeId))
}
